'use strict';

import template from './template.html';


export default function() {
	return {template: template};
}
